import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import {
  Select,
  MenuItem,
  Avatar,
  Grid,
  Paper,
  Modal,
  Container,
  Typography,
  TextField,
  Button,
} from "@material-ui/core";
import { useUserContext } from "../../../context/UserContext";
import ImageCropProfile from "../../FormDialog/ImageCropProfile";
import api from "../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import MuiAlert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import ImgNotAvailable from "../../../assets/images/imgNotAvailable.jpg";
import RemoveProfilePic from "../../FormDialog/RemoveProfilePic";

import useStyles from "./styles";
import Pal from "../../../themes/palette";

export default function ViewReports() {
  const classes = useStyles();
  // context
  const { store } = useUserContext();
  const token = store.data.token;

  ///////////////////////////Buyer Details Start/////////////////////////////////////////////////////
  const [reportDetails, setReportDetails] = useState({
    subject: "",
    description: "",
    screenshot: "",
  });
  // Modal Settings here
  const [modalOpenn, setModelOpenn] = useState(false);

  const handleOpenn = () => {
    setModelOpenn(true);
  };

  const handleClosen = () => {
    setModelOpenn(false);
  };
  const handleReportDetails = (input) => (e) => {
    setReportDetails({ ...reportDetails, [input]: e.target.value });
  };

  const editReportHandler = (e) => {
    console.log(reportDetails);
    e.preventDefault();

    const { subject, description, screenshot } = reportDetails;

    api
      .patch(
        `/superAdmin/problem/${reportDetails._id}`,
        {
          subject,
          description,
          screenshot,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        try {
          const newDetails = details.map((prod) =>
            prod._id === reportDetails._id ? reportDetails : prod
          );
          setDetails(newDetails);
          handleClose();
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "SUCCESS: Report Info has been Updated!",
            open: true,
          });
        } catch (error) {}
      })
      .catch((error) => {
        handleClose();
        setSnackBar({
          ...snackBarstate,
          message:
            "ERROR: " + JSON.stringify(error.response.data.error.message),
          type: "error",
          open: true,
        });
      });
  };
  const handerChangeStatus = (id) => async (e) => {
    let newStatus = e.target.value;
    const newComplaintsList = details.map((el) =>
      el._id === id ? { ...el, isProblemResolved: newStatus === "true" } : el
    );

    console.log(newComplaintsList);

    await api
      .patch(
        `/superAdmin/problem/${id}`,
        { isProblemResolved: newStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Status has been Changed!",
          open: true,
        });
        setDetails(newComplaintsList);
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went Wrong!",
          open: true,
        });
      });
  };

  ////////////////image upload settings start//////////////////////////////////
  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);
  const onSelectlogo = (image) => {
    setReportDetails({ ...reportDetails, screenshot: image });
  };
  // Show delete ProfilePic dialog
  const handlerRemoveProfilePic = (e) => {
    e.preventDefault();
    setIsProfilePicRemove(true);
  };

  const confirmedRemoveProfilePic = () => {
    setReportDetails({ ...reportDetails, screenshot: null });
    setIsProfilePicRemove(false);
  };

  /////////////// Snackbar///////////////////////////////////////////////////////////////////
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  ///////////////Snack Bar ///////////////////////////////////////////////////////////////////

  // Edit Product Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };

  const getAllReports = async () => {
    await api
      .get("/superAdmin/view/system/problems", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("problems are ", res.data.data.problems);
        setDetails(res.data.data.problems);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  /////////////////Ending /////////////////////////////////////////////////////////////////////

  const [details, setDetails] = useState();

  const columns = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    {
      title: "Screenshot",
      field: "screenshot",
      render: ({ screenshot }) => (
        <img
          src={screenshot != null ? screenshot : ImgNotAvailable}
          alt="Profile Pic"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
    },
    {
      title: "Subject",
      field: "subject",
      width: 150,
    },
    {
      title: "Description",
      field: "description",
      width: 150,
    },
    {
      title: "Time",
      field: "createdAt",
      width: 150,
    },
    {
      title: "Status",
      field: "isProblemResolved",
      align: "center",
      render: ({ isProblemResolved }) => (
        <div
          style={{
            height: 30,
            width: 100,
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
            background:
              isProblemResolved === true
                ? "rgba(112, 224, 0, 0.7)"
                : "rgba(231, 76, 60, 0.7)",

            color: "#262626",
            borderRadius: 4,
          }}
        >
          <div
            style={{
              background:
                isProblemResolved === true
                  ? "rgba(112, 224, 0, 0.7)"
                  : "rgba(231, 76, 60, 0.7)",

              width: 15,
              height: 15,
              borderRadius: 8,
              marginRight: 5,
              marginLeft: 5,
            }}
          ></div>
          {isProblemResolved === true ? "Resolved" : "Unresolved"}
        </div>
      ),
    },
    {
      field: "",
      title: "Actions",
      align: "center",
      render: (rowData) => (
        <div>
          <Select
            id="status"
            style={{ marginTop: 8 }}
            defaultValue={"DEFAULT"}
            onChange={handerChangeStatus(rowData._id)}
          >
            <MenuItem value="DEFAULT" disabled>
              Status
            </MenuItem>
            <MenuItem value="true">Resolved</MenuItem>
            <MenuItem value="false">Un-Resolved</MenuItem>
          </Select>
        </div>
      ),
      export: false,
    },
  ];

  useEffect(() => {
    // fetching List of Buyers from API
    getAllReports();
    // eslint-disable-next-line
  }, []);

  return (
    <Grid container className={classes.root}>
      {/* {isLoggedOut ? <Redirect to="/admin/login" /> : ""} */}
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <MaterialTable
          title="All Problems Reported By The Sellersss"
          data={details}
          columns={columns}
          actions={[
            (rowData) => ({
              icon: () => <EditIcon />,
              tooltip: "Edit",
              onClick: (event, rowData) => {
                setReportDetails(rowData);
                handleOpen();
              },
            }),
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: Pal.palette.primary.main,
              color: "#fff",
              whiteSpace: "nowrap",
            },
            exportButton: true,
            tableLayout: "auto",
          }}
        />
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
      </Grid>
      {/* //////////////////////////////////////////////////Edit Buyer///////////////////////////////////////// */}
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container component={Paper} maxWidth="md" style={{ padding: 20 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">Edit Buyer</Typography>
            </Grid>
            <form className={classes.form} noValidate style={{ padding: 20 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    autoFocus
                    margin="dense"
                    variant="outlined"
                    autoComplete="fName"
                    required
                    fullWidth
                    label="Subject"
                    name="fname"
                    value={reportDetails.subject}
                    onChange={handleReportDetails("subject")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Decription"
                    id="email"
                    name="email"
                    value={reportDetails.description}
                    onChange={handleReportDetails("description")}
                  />
                </Grid>
              </Grid>

              {/*///////////////////////// image upload option /////////////////////////////*/}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <Avatar
                  alt="profile photo"
                  src={reportDetails.screenshot}
                  className={classes.avatarInProfileSetting}
                >
                  {"Pic HERE"}
                </Avatar>
                <div style={{ marginTop: 50 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenn}
                  >
                    <AddAPhotoIcon
                      style={{
                        marginRight: 5,
                        fontSize: 22,
                        marginBottom: 5,
                      }}
                    />
                    Upload
                  </Button>
                  <Button
                    onClick={handlerRemoveProfilePic}
                    style={{ color: "red" }}
                    color="red"
                  >
                    Remove Image
                  </Button>
                </div>
              </div>
              <Grid item xs={12} sm={12} md={12} align="right">
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: 10 }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={editReportHandler}
                >
                  Save Changes
                </Button>
                <RemoveProfilePic
                  RemoveProfilePic={isProfilePicRemove}
                  setRemoveProfilePic={setIsProfilePicRemove}
                  confirmedRemoveProfilePic={confirmedRemoveProfilePic}
                />
              </Grid>
            </form>
          </Grid>
        </Container>
      </Modal>
      <Modal
        open={modalOpenn}
        onClose={handleClosen}
        onBackdropClick={handleClosen}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            width: "70vw",
            height: "70vh",
            padding: "20px",
            position: "relative",
          }}
        >
          <ImageCropProfile
            onProfileChange={onSelectlogo}
            handleClose={handleClosen}
          />
        </div>
      </Modal>
    </Grid>
  );
}
